import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { I18nProvider } from './i18n/I18nProvider';
import { relayAuthPopupIfOpener } from './services/genesys-api';
import { t } from './services/language-manager';
import { clearLegacyGenesysToken } from './services/token-store';
import './styles/global.css';

// Older builds kept the Genesys token in localStorage. It now lives only in this tab.
clearLegacyGenesysToken();

// Auth-popup callback: Genesys redirected this window to index.html with
// ?code= / ?error=. Relay to the iframe opener and do not mount the wizard.
if (relayAuthPopupIfOpener()) {
  // The Platform SDK in the opener closes this window after exchanging the code.
  document.title = t('signin-popup-title');
} else {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <I18nProvider>
        <App />
      </I18nProvider>
    </React.StrictMode>,
  );
}
